@if ({canEdit: canAdministerLicense()}; as permission) {
  <div class="license-holder-section-header">
    <h3 class="license-holder-section-title" id="license-holder-holders-title-{{ salesforceLicense().license_id }}">
      {{ 'license-management_licensed-users' | translate }}
    </h3>
    <button
      type="button"
      class="goreact-btn link-btn license-holder-section-toggle"
      (click)="toggleHoldersExpanded()"
      [attr.aria-controls]="'license-holder-holders-panel-' + salesforceLicense().license_id"
      [attr.aria-expanded]="holdersExpanded()"
      [attr.aria-label]="(holdersExpanded() ? 'license-management_collapse-section' : 'license-management_expand-section') | translate:{section: ('license-management_licensed-users' | translate)}">
      {{ holdersExpanded() ? ('license-management_collapse' | translate) : ('license-management_expand' | translate) }}
    </button>
  </div>
  <div class="license-holder-progress" [attr.aria-hidden]="!holdersLoading()">
    @if (holdersLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
  @if (holdersExpanded()) {
    <div
      [class.is-loading]="holdersLoading()"
      id="license-holder-holders-panel-{{ salesforceLicense().license_id }}"
      role="region"
      [attr.aria-labelledby]="'license-holder-holders-title-' + salesforceLicense().license_id">
      <table class="license-holder-table license-holder-table--holders">
        <thead>
          <tr>
            <th class="cell-with-padding-left" translate="common_users"></th>
            <th class="license-permission-th" translate="license-management_permissions"></th>
            <th translate="license-management_date-invited"></th>
            <th translate="license-management-date-accepted"></th>
            <th>
              {{ 'license-management_seat-used' | translate}}
              <span
                [matTooltip]="'license-management_instructor-seat-used-tooltip' | translate"
                class="ficon-help">
              </span>
            </th>
            <th class="action-cell"></th>
          </tr>
        </thead>
        <tbody>
          @for (holder of licenseHolders(); track holder) {
            <tr>
              <td class="cell-with-padding-left">
                @if (holder.user) {
                  <span>
                    @if (auth.isAdmin()) {
                      <span>
                        {{ holder.user.user_id }} &#8212;
                      </span>
                    }
                    {{ holder.user.first_name }} {{ holder.user.last_name }}
                  </span>
                }
                @if (holder.user) {
                  <span class="user-email text-secondary">
                    ({{ holder.user.email }})
                  </span>
                }
              </td>
              <td>
                <mat-form-field class="license-holder-permission" subscriptSizing="dynamic">
                  <mat-select [value]="holder.is_admin" (selectionChange)="permissionChange($event, holder)" [disabled]="!canUpdateHolder(holder) || !permission.canEdit">
                    <mat-option [value]="true">
                      {{ 'license-management_permissions-admin' | translate}}
                    </mat-option>
                    <mat-option [value]="false">
                      {{ 'license-management_permissions-instructor' | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
                </mat-form-field>
              </td>
              <td>
                @if (holder.invite) {
                  <span>
                    {{ holder.invite.created_at | date: 'short':'UTC' }}
                  </span>
                }
                @if (!holder.invite) {
                  <span>
                    {{ holder.created_at | date: 'short':'UTC' }}
                  </span>
                }
              </td>
              <td>
                @if (holder.user) {
                  <span>
                    {{ holder.created_at | date: 'short':'UTC' }}
                  </span>
                }
              </td>
              <td>
                @if (permission.canEdit) {
                  <button type="button"
                    class="view-seats-lnk goreact-btn link-btn"
                    (click)="viewSeats(holder)">
                    {{holder.seats_consumed}}
                  </button>
                }
                @if (!permission.canEdit) {
                  <div>{{holder.seats_consumed}}</div>
                }
              </td>
              <td class="action-cell">
                @if (canRemoveHolder(holder) && permission.canEdit) {
                  <button
                    mat-button
                    (click)="removeUser(holder)"
                    [disabled]="$any(holder).removing">
                    @if (!$any(holder).removing) {
                      <i class="ficon-app-x"></i>
                    }
                    @if ($any(holder).removing) {
                      <i class="ficon-spinner ficon-spin"></i>
                    }
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
        @if (permission.canEdit) {
          <tfoot>
            <tr>
              <td colspan="6">
                <button mat-flat-button class="goreact-btn secondary-btn" (click)="addUsers()">
                  <mat-icon class="ficon-add"></mat-icon>
                  <span translate="license-management_add-user"></span>
                </button>
              </td>
            </tr>
          </tfoot>
        }
      </table>
      @if (holdersPaginationMeta(); as meta) {
        <mat-paginator
          class="license-holder-paginator"
          [length]="meta.total"
          [pageIndex]="holdersPageIndex()"
          [pageSize]="meta.per_page || holdersPageSize"
          [pageSizeOptions]="[meta.per_page || holdersPageSize]"
          [hidePageSize]="true"
          [showFirstLastButtons]="true"
          (page)="onHoldersPageChange($event)">
        </mat-paginator>
      }
    </div>
  }
  <div class="license-holder-section-header">
    <h3 class="license-holder-section-title" id="license-holder-invites-title-{{ salesforceLicense().license_id }}">
      {{ 'license-management_pending-invitations' | translate }}
    </h3>
    <button
      type="button"
      class="goreact-btn link-btn license-holder-section-toggle"
      (click)="toggleInvitesExpanded()"
      [attr.aria-controls]="'license-holder-invites-panel-' + salesforceLicense().license_id"
      [attr.aria-expanded]="invitesExpanded()"
      [attr.aria-label]="(invitesExpanded() ? 'license-management_collapse-section' : 'license-management_expand-section') | translate:{section: ('license-management_pending-invitations' | translate)}">
      {{ invitesExpanded() ? ('license-management_collapse' | translate) : ('license-management_expand' | translate) }}
    </button>
  </div>
  <div class="license-holder-progress" [attr.aria-hidden]="!invitesLoading()">
    @if (invitesLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
  @if (invitesExpanded()) {
    <div
      [class.is-loading]="invitesLoading()"
      id="license-holder-invites-panel-{{ salesforceLicense().license_id }}"
      role="region"
      [attr.aria-labelledby]="'license-holder-invites-title-' + salesforceLicense().license_id">
      <table class="license-holder-table license-holder-table--invites">
        <thead>
          <tr>
            <th class="cell-with-padding-left" translate="license-management_invited-users"></th>
            <th class="license-permission-th" translate="license-management_permissions"></th>
            <th translate="license-management_date-invited"></th>
            <th class="action-cell"></th>
          </tr>
        </thead>
        <tbody>
          @for (invite of licenseHolderInvites(); track invite) {
            <tr>
              <td class="cell-with-padding-left">
                <span class="user-email text-secondary">
                  ({{ invite.email }})
                </span>
              </td>
              <td>
                <mat-form-field class="license-holder-permission" subscriptSizing="dynamic">
                  <mat-select [value]="invite.is_admin" (selectionChange)="permissionChange($event, invite)" [disabled]="!canUpdateHolder(invite) || !permission.canEdit">
                    <mat-option [value]="true">
                      {{ 'license-management_permissions-admin' | translate}}
                    </mat-option>
                    <mat-option [value]="false">
                      {{ 'license-management_permissions-instructor' | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
                </mat-form-field>
              </td>
              <td>
                {{ invite.created_at | date: 'short':'UTC' }}
              </td>
              <td class="action-cell">
                @if (canRemoveHolder(invite) && permission.canEdit) {
                  <button
                    mat-button
                    (click)="removeUser(invite)"
                    [disabled]="$any(invite).removing">
                    @if (!$any(invite).removing) {
                      <i class="ficon-app-x"></i>
                    }
                    @if ($any(invite).removing) {
                      <i class="ficon-spinner ficon-spin"></i>
                    }
                  </button>
                }
              </td>
            </tr>
          }
          @if (!invitesLoading() && licenseHolderInvites().length === 0) {
            <tr>
              <td class="cell-with-padding-left license-holder-zero-state" colspan="4">
                {{ 'group-settings_no-pending-invitations' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (invitesPaginationMeta(); as meta) {
        <mat-paginator
          class="license-holder-paginator"
          [length]="meta.total"
          [pageIndex]="invitesPageIndex()"
          [pageSize]="meta.per_page || invitesPageSize"
          [pageSizeOptions]="[meta.per_page || invitesPageSize]"
          [hidePageSize]="true"
          [showFirstLastButtons]="true"
          (page)="onInvitesPageChange($event)">
        </mat-paginator>
      }
    </div>
  }
}
